import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ACLService } from '@delon/acl';
import { CacheService } from '@delon/cache';
import { AppService } from '@root/app.service';
import { OptionService } from '@root/router/index/option.service';
import { TranslateService } from '@root/shared/service/translate.service';

@Component({
  selector: 'host-operate-bar',
  templateUrl: './operate-bar.component.html',
  styleUrls: ['./operate-bar.component.scss'],
})
export class OperateBarComponent implements OnInit {
  _type: 'status' | 'price' = 'status';
  @Input()
  get type() {
    return this._type;
  }
  set type(value) {
    this._type = value;
    // const optionsOfStatusFilter = this.isInternational
    //   ? [...this.optionsOfStatusFilter, { label: 'Room status', value: 'room_status' }]
    //   : this.optionsOfStatusFilter;
    const optionsOfStatusFilter = [...this.optionsOfStatusFilter];
    if (this.isInternational) {
      optionsOfStatusFilter.push({ label: 'Room status', value: 'room_status', i18nKey: 'Room status' });
    }

    if (!this.isSubaccount) {
      optionsOfStatusFilter.push({
        label: 'Team accounts',
        value: 'team_accounts',
        i18nKey: 'placeholder.subaccount_for_house_filter',
      });
    }
    this.optionsOfFilter = this.type === 'status' ? optionsOfStatusFilter : this.optionsOfChannelFilter;
  }
  @Input() form: UntypedFormGroup;
  @Input() displayStock = true;
  @Input() listOfMonthOptions = [];
  @Input() listOfThirdpartyOptions = [];
  @Input() listOfTodayInfoOptions = [];
  @Input() listOfSubaccountOptions = [];
  @Output() onClickSync: EventEmitter<any> = new EventEmitter();
  @Output() onClickDisplayPriceTip: EventEmitter<any> = new EventEmitter();
  @Output() onToggleDisplayStock: EventEmitter<boolean> = new EventEmitter();

  private readonly optionsOfStatusFilter = [
    { label: 'Group', value: 'group', i18nKey: 'word.group' },
    { label: 'Room type', value: 'room_type', i18nKey: 'router.static.house_type' },
    { label: 'Cleaning status', value: 'cleaning_status', i18nKey: 'placeholder.any_clean_status' },
  ];

  private readonly optionsOfChannelFilter = [
    { label: 'Channel', value: 'channel', i18nKey: 'placeholder.channel' },
    { label: 'Group', value: 'group', i18nKey: 'word.group' },
    { label: 'Room type', value: 'room_type', i18nKey: 'router.static.house_type' },
  ];

  listOfCleaningOption = [
    { label: '不限状态', value: null, i18nKey: 'word.any_status' },
    { label: '脏房', value: 3, i18nKey: 'word.room_not_cleaned' },
    { label: '净房', value: 1, i18nKey: 'word.cleaned' },
    // { label: "免打扫", value: 0, i18nKey: "word.no_cleaning" },
    // { label: "保洁中", value: 2, i8nKey: "cleaning" },
  ];

  get optionsOfGroup() {
    return this.optSrv.optionsOfHouseGroup;
  }

  get isInternational() {
    return this.app.app.international;
  }

  get isSubaccount() {
    return this.acl.can({ role: ['slave'] });
  }

  optionsOfFilter = [];

  filters =
    (this.cache.getNone('calendar_filter') as Array<any>) ||
    [
      // "house_ids",
      // "channels",
      // "thirdparty_account_ids",
    ];

  constructor(
    private cdr: ChangeDetectorRef,
    private acl: ACLService,
    private app: AppService,
    private optSrv: OptionService,
    private cache: CacheService,
    private t: TranslateService
  ) {}

  ngOnInit() {}

  onFilterChange(value) {
    const key = 'calendar_filter';
    this.cache.set(key, value);
  }
}
